/**
 * loader methods
 */
const loaderElementId = 'innerLoaderId';
const Loader = {
  show() {
    const loaderElement = document.getElementById(loaderElementId);
    loaderElement.style.display = 'block';
  },
  hide() {
    const loaderElement = document.getElementById(loaderElementId);
    loaderElement.style.display = 'none';
  }
};

export default Loader;


// WEBPACK FOOTER //
// ./utils/Loader/index.js